export default __webpack_public_path__ + "static/media/parking.0e146160.jpg";